module.exports = __webpack_public_path__ + "img/scope-resources.7f4bde99.png";